import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useSelector } from "react-redux";
import { selectors } from "../../redux-store";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chartPaper: {
      height: 400,
      width: "100%",
      marginBottom: "10px",
    },
  }),
);

const useSubscribedAndReachedPerEventBarChart = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const devicesCount = useSelector(
    selectors.getSubscribedAndReachedPerEventList,
  );
  const [t] = useTypedTranslations();

  const data = useMemo(() => {
    if (devicesCount) {
      const data: {
        id: string;
        title: string;
        subscribed: number;
        subscribedColor: string;
        reached: number;
        reachedColor: string;
      }[] = devicesCount.map((devCount) => {
        const subsCount = devCount.devicesSubscribedCount;
        const reachedCount = devCount.devicesReachedCount;
        return {
          id: devCount.eventId,
          title: devCount.eventTitle,
          subscribed: subsCount,
          subscribedColor: "hsl(244, 70%, 50%)",
          reached: reachedCount,
          reachedColor: "hsl(147, 70%, 50%)",
        };
      });
      return data;
    }
  }, [devicesCount]);

  //console.log(data[0]);
  //console.log(data[1]);

  return {
    styles,
    classes,
    atomicStyles,
    data,
    t,
  };
};

export { useSubscribedAndReachedPerEventBarChart as default };
